import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);
        jQuery(document).ready(function () {

            /***
            Desktop functionality
            ***/

            // Show lazy menu icons on hover
            let $submenus       = $('.ic-main-nav > li');
            let $icons          = $submenus.find('.lazy-menu-icon');
            let $mobileSubmenus = $('.ic-mobile-nav > li');
            let $mobileIcons    = $mobileSubmenus.find('.lazy-menu-icon');
            let loaded = false;
            let mobileLoaded    = false;

            function loadIcons(screen) {
                if (screen === 'desktop') {
                    $icons.each(function() {
                        let src = $(this)[0].dataset.original;
                        $(this).replaceWith('<img class="menu-item-icon" src="' + src + '"/>');
                    })
                    loaded = true;
                } else {
                    $mobileIcons.each(function() {
                        let src = $(this)[0].dataset.original;
                        $(this).replaceWith('<img class="menu-item-icon" src="' + src + '"/>');
                    })
                    mobileLoaded = true;
                }
            }

            $submenus.each(function() {
                $(this).hover(function() {
                    if (!loaded) {
                        loadIcons('desktop');
                    }
                })
            });

            // Education dropdown menus
            let $edMenus = $('.ed-dropdown > ul.dropdown-menu');

            // Hide submenus by default on load
            function hideEdMenus() {
                $edMenus.each(function() {
                    $(this).hide();
                });
            }
            hideEdMenus();

            // Show and hide submenus on click
            // Works for mobile too
            let $dropdowns = $('.ed-dropdown');
            $dropdowns.click(function(e) {
                $dropdowns.not($(this)).find('ul.dropdown-menu').hide();
                $dropdowns.not($(this)).find('a.dropdown-item span.plus').html('+');
                if ($(this).find('a.dropdown-item span.plus').html() === '+') {
                    $(this).find('a.dropdown-item span.plus').html('-');
                } else {
                    $(this).find('a.dropdown-item span.plus').html('+');
                }
                $(this).find('ul.dropdown-menu').toggle();
            });

            // Search functionality
            let $searchText = $('p.search-text');
            let $searchBar  = $('.header-search input');
            let $searchIcon = $('#searchSubmit');

            let $searchTextMobile = $('.header-search-mobile p.search-text');
            let $searchBarMobile  = $('.header-search-mobile input');
            let $searchIconMobile = $('.header-search-mobile #searchSubmit');

            // (Desktop) Toggle search bar visibility
            function toggleSearch() {
                if ($searchBar.hasClass('open')) {
                    $searchBar.removeClass('open');
                } else {
                    $searchBar.addClass('open').focus();
                }
            }

            // (Desktop) Toggle search bar open/close on click
            $searchText.click(function() {
                toggleSearch();
            });

            // (Desktop) Open search bar when icon is clicked and prevent empty searches
            $searchIcon.click(function(e) {
                console.log($searchBar.val());
                if (!$searchBar.hasClass('open') || !$searchBar.val()) {
                    e.preventDefault();
                    toggleSearch();
                }
            });

            // (Mobile) Prevent empty searches on button click
            $searchIconMobile.click(function(e) {
                console.log($searchBarMobile.val());
                if (!$searchBarMobile.val()) {
                    e.preventDefault();
                }
            });


            /***
            Mobile functionality
            ***/

            // Breakpoint references
            let sm = 576,
                md = 768,
                lg = 992,
                xl = 1200;

            // Viewport width helper function
            function viewport() {
                let e = window,
                    a = 'inner';
                if (!('innerWidth' in window)) {
                    a = 'client';
                    e = document.documentElement || document.body;
                }
                return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
            }

            let vpWidth       = viewport().width;

            // Scroll color change functionality
            let $html         = $('html');
            let $body         = $('body');
            let $header       = $('header');
            function headerCheck() {
                let $scrollTop = $(window).scrollTop();
                if ($body.hasClass('has-alert-bar')) {
                    if ($scrollTop > 45) {
                        $header.addClass('scrolled');
                    } else {
                        $header.removeClass('scrolled');
                    }
                } else {
                    if ($scrollTop > 0) {
                        $header.addClass('scrolled');
                    } else {
                        $header.removeClass('scrolled');
                    }
                }
            }

            // Check header on load in case page is scrolled
            headerCheck();

            // Hamburger mobile menu button functionality
            let $mainMenu   = $('.header-main');
            let $hamburger  = $(".hamburger");
            let $mobileMenu = $('.header-mobile');
            $hamburger.click(function() {
                $(this).toggleClass('is-active');
                if ($mobileMenu.hasClass('nav-disabled')) {
                    $mobileMenu.removeClass('nav-disabled');
                    $mainMenu.addClass('open');
                    if (!mobileLoaded) {
                        loadIcons('mobile');
                    }
                } else {
                    resetMenu();
                }
            });

            // Mobile menu item submenus functionality
            let $mobileMenuItems = $('.ic-mobile-nav > li > a.dropdown-toggle');
            $mobileMenuItems.each(function() {
                let $dropdown     = $(this).siblings('ul.dropdown-menu');
                let $plus         = $(this).find('span.plus');
                $(this).click(function(e) {
                    if (!$(this).parent().hasClass('no-submenu')) {
                        e.preventDefault();
                        $dropdown.toggleClass('open');
                        if ($plus.html() === '+') {
                            $plus.html('-');
                        } else {
                            $plus.html('+');
                        }
                    }
                })
            });

            // Reset mobile menu when closed, or if screen is resized
            function resetMenu() {
                let $mobileSubMenus = $('.ic-mobile-nav > li > ul.dropdown-menu');
                $mobileSubMenus.each(function() {
                    $(this).removeClass('show');
                });
                $hamburger.removeClass('is-active');
                $mobileMenu.addClass('nav-disabled');
                $mainMenu.removeClass('open');
                $html.removeClass('stick');
                $body.removeClass('stick');
                hideEdMenus();
            }

            $(window).resize(function() {
                resetMenu();
                //location.reload();
            });

            // Check for scrolling to adjust header position and styles
            $(window).scroll(function() {
                headerCheck();
            });
        });
    }
}